<template>
  <div
    class="paginator"
    v-if="isShowPaginator"
  >
    <button
      v-if="isShowFirstPage"
      class="paginator__left-arrows"
      type="button"
      v-on:click="onClick(1)"
    />
    <button
      v-if="isShowLeftArrow"
      class="paginator__left-arrow"
      type="button"
      v-on:click="onClick(value - 1)"
    />
    <button
      v-for="page in pages"
      v-bind:key="page"
      type="button"
      class="paginator__item"
      v-bind:class="{ current: page === value }"
      v-on:click="onClick(page)"
    >{{ page }}</button>
    <button
      v-if="isShowRightArrow"
      class="paginator__right-arrow"
      type="button"
      v-on:click="onClick(value + 1)"
    />
    <button
      v-if="isShowLastPage"
      class="paginator__right-arrows"
      type="button"
      v-on:click="onClick(pageCount)"
    />
  </div>
</template>

<script>

/**
 * @description Количество страниц для отрисовки.
 * @type {number}
 */
const SIZE = 2;

/**
 * @description Пагинация страниц.
 * @type {any}
 */
export default {
  computed: {
    isShowFirstPage() {
      return this.value > this.visibleCount + 1;
    },
    isShowLeftArrow() {
      return this.value > 1;
    },
    isShowRightArrow() {
      return this.value < this.pageCount;
    },
    isShowLastPage() {
      return this.value < this.pageCount - this.visibleCount;
    },
    isShowPaginator() {
      return this.pageCount >= this.visibleCount;
    },
    pages() {
      const from = Math.max(this.value - this.visibleCount, 1);
      const to = Math.min(this.value + this.visibleCount, this.pageCount);
      const pageNumbers = [];
      for (let i = from; i <= to; i += 1) {
        pageNumbers.push(i);
      }
      return pageNumbers;
    },
  },
  name: 'ThePagination',
  methods: {
    onClick(pageNumber) {
      this.$emit('input', pageNumber);
    },
  },
  props: {
    /**
     * @description Количество страниц.
     * @type {number}
     */
    pageCount: { required: true, type: Number },
    /**
     * @description Значение.
     * @type {number}
     */
    value: { required: true, type: Number },
    /**
     * @description Максимальное количество номеров страниц для показа.
     * @type {number}
     */
    visibleCount: { default: () => SIZE, type: Number },
  },
};
</script>

<style scoped lang="scss">
.paginator {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: row;
  &__left {
    &-arrows {
      width: 36px;
      min-width: 36px;
      height: 36px;
      background-image: url("@/assets/img/arrow/arrows-blue.svg");
      background-position: center;
      background-repeat: no-repeat;
    }
    &-arrow {
      width: 36px;
      min-width: 36px;
      height: 36px;
      background-image: url("@/assets/img/arrow/arrow-blue.svg");
      background-position: center;
      background-repeat: no-repeat;
    }
  }
  &__right {
    &-arrows {
      width: 36px;
      min-width: 36px;
      height: 36px;
      background-image: url("@/assets/img/arrow/arrows-blue.svg");
      transform: rotate(-180deg);
      background-position: center;
      background-repeat: no-repeat;
    }
    &-arrow {
      width: 36px;
      min-width: 36px;
      height: 36px;
      background-image: url("@/assets/img/arrow/arrow-blue.svg");
      transform: rotate(-180deg);
      background-position: center;
      background-repeat: no-repeat;
    }
  }
  &__item {
    display: flex;
    align-items: center;
    justify-content: center;
    background: #ffffff;
    color: #0489e0;
    font-size: 16px;
    width: 36px;
    height: 36px;
    border: 2px solid #eaeff3;
    border-radius: 6px;
    text-decoration: none !important;
    padding: 5px;
    margin: 5px;
    &:hover {
      color: #ffffff;
      background: #0489e0;
      border: 2px solid #0489e0;
    }
    &.current {
      color: #FFFFFF;
      background: #0489E0;
      border: 2px solid #0489E0;
    }
  }
}
@media screen and (max-width: 480px) {
  .paginator {
    &__left {
      &-arrows {
        width: 24px;
        min-width: 24px;
      }
      &-arrow {
        width: 16px;
        min-width: 16px;
      }
    }
    &__right {
      &-arrows {
        width: 24px;
        min-width: 24px;
      }
      &-arrow {
        width: 16px;
        min-width: 16px;
      }
    }
  }
}
</style>
